import React from 'react';
import { ArrowRight } from '../icons';

const CTA = ({ t }) => (
  /* full-width navy bg */
  <div className="w-full bg-navy text-white">
    {/* max-width content */}
    <div className="max-w-[1440px] mx-auto px-[120px] h-[320px] box-border flex items-center justify-between gap-16">

      {/* Text block */}
      <div className="flex flex-col gap-[18px] max-w-[800px]">
        <h2 className="m-0 font-heading font-medium text-[48px] leading-[1.1] tracking-[-0.01em]">
          {t.ctaTitle}
        </h2>
        <p className="m-0 text-[18px] text-white/90">{t.ctaSub}</p>
      </div>

      {/* Button */}
      <a
        className="btn shrink-0 flex items-center gap-3 h-14 px-[34px] rounded-[3px] bg-gold text-navy-deep text-[13px] font-bold tracking-widest uppercase"
        href="#"
      >
        {t.enquireNow} <ArrowRight size={18} />
      </a>
    </div>
  </div>
);

export default CTA;
